// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GenerateWinninAIReportModal {
  padding: 32px;
  background-color: var(--color_neutral_0);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: flex-start;
  justify-content: space-between;
}
.GenerateWinninAIReportModal-actions {
  align-self: flex-end;
  display: flex;
  gap: 24px;
}
.GenerateWinninAIReportModal-content {
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: flex-start;
}
.GenerateWinninAIReportModal-FirstModalContent {
  max-width: 522px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.GenerateWinninAIReportModal-FirstModalContent span {
  font-weight: var(--bold_weight);
}
.GenerateWinninAIReportModal-FirstModalContent-description {
  color: #4c5667;
  color: var(--gray_dark2, #4c5667);
  font-size: 14px;
  font-weight: 400;
  line-height: 160%; /* 22.4px */
}
.GenerateWinninAIReportModal-FirstModalContent-card-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 8px;
  gap: 8px;
}
.GenerateWinninAIReportModal-FirstModalContent-card-container button:nth-last-of-type(2) {
  height: 110px;
}
.GenerateWinninAIReportModal-FirstModalContent-card-container [class*=dist_BigButtonCard-disabled] {
  cursor: default;
}
.GenerateWinninAIReportModal-FirstModalContent-text {
  margin-bottom: 3px;
  color: #4c5667;
  color: var(--gray_dark1, #4c5667);
  font-size: 12px;
  font-weight: 400;
  line-height: 148.5%; /* 17.82px */
}
.GenerateWinninAIReportModal-FirstModalContent-chip-container {
  display: flex;
  gap: 8px;
  margin-top: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/GenerateWinninAIReportModal/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,8BAAA;AACF;AACE;EACE,oBAAA;EACA,aAAA;EACA,SAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;AAAJ;AAGE;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AADJ;AAGI;EACE,+BAAA;AADN;AAII;EACE,cAAA;EAAA,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAFN;AAKI;EACE,aAAA;EACA,8BAAA;EACA,aAAA;EAAA,QAAA;AAHN;AAKM;EACE,aAAA;AAHR;AAMM;EACE,eAAA;AAJR;AAQI;EACE,kBAAA;EACA,cAAA;EAAA,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA,EAAA,YAAA;AANN;AASI;EACE,aAAA;EACA,QAAA;EACA,eAAA;AAPN","sourcesContent":[".GenerateWinninAIReportModal {\n  padding: 32px;\n  background-color: var(--color_neutral_0);\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  align-items: flex-start;\n  justify-content: space-between;\n\n  &-actions {\n    align-self: flex-end;\n    display: flex;\n    gap: 24px;\n  }\n\n  &-content {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    align-items: flex-start;\n  }\n\n  &-FirstModalContent {\n    max-width: 522px;\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n\n    span {\n      font-weight: var(--bold_weight);\n    }\n\n    &-description {\n      color: var(--gray_dark2, #4c5667);\n      font-size: 14px;\n      font-weight: 400;\n      line-height: 160%; /* 22.4px */\n    }\n\n    &-card-container {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      gap: 8px;\n\n      button:nth-last-of-type(2) {\n        height: 110px;\n      }\n\n      [class*='dist_BigButtonCard-disabled'] {\n        cursor: default;\n      }\n    }\n\n    &-text {\n      margin-bottom: 3px;\n      color: var(--gray_dark1, #4c5667);\n      font-size: 12px;\n      font-weight: 400;\n      line-height: 148.5%; /* 17.82px */\n    }\n\n    &-chip-container {\n      display: flex;\n      gap: 8px;\n      margin-top: 4px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
